import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

// Scrolls to the top of the page on SPA navigation only. POP (back/forward)
// is intentionally left alone so the browser's built-in scroll restoration
// can return the user to where they were. Crucially this avoids firing on
// initial mount, which on a full reload would clobber the scroll position
// the browser just restored.
const ScrollToTopOnSpaNav = (): null => {
  const history = useHistory()

  useEffect(
    () =>
      history.listen((_location, action) => {
        if (action === 'PUSH' || action === 'REPLACE') {
          window.scrollTo(0, 0)
        }
      }),
    [history]
  )

  return null
}

export default ScrollToTopOnSpaNav
